<template>
<div class="component">
    <div class="searchField columns is-mobile is-multiline">
        <div class=" column is-2-tablet is-12-mobile label">
            <h1 class="title">{{$t('enaq_translation_default_search')}}</h1>
        </div>
        <div class="column is-10-tablet is-12-mobile"> <input type="text" class="input" v-model="searchInput" />
        </div>
    </div>
    <br>
    <div class="enaqmap ">
        <canvas id="tutorial" ref="my-canvas" :width="canvasWidth" :height="canvasHeight"></canvas>

    </div>
</div>
</template>

<script>
export default {
    name: 'Enaqmap',
    props: [],
    mounted: function () {
        this.initCanvas()
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            canvas: null,
            canvasContext: null,
            rooms: [],
            backgroundImage: null,
            elementOffsetTop: 0,
            elementOffsetLeft: 0,
            houseImage: null,
            streets: [],
            searchInput: ''
        }
    },
    methods: {
        initCanvas() {
            this.canvas = this.$refs['my-canvas']
            this.canvasContext = this.canvas.getContext("2d")
            this.elementOffsetLeft = this.canvas.offsetLeft;
            this.elementOffsetTop = this.canvas.offsetTop;
            this.canvas.addEventListener('click', function (event) {
                this.elementOffsetLeft = this.canvas.offsetLeft;
                this.elementOffsetTop = this.canvas.offsetTop;
                if (this.roomList.length <= 0) {
                    return;
                }
                var x = event.pageX - this.canvas.offsetLeft,
                    y = event.pageY - this.canvas.offsetTop;
                this.roomList.forEach(function (element) {
                    if (y > element.y - (element.height / 2) && y < element.y - (element.height / 2) + element.height &&
                        x > element.x - (element.width / 2) && x < element.x - (element.width / 2) + element.width) {
                        console.log('clicked an element: ' + element.name);
                        this.sendInfoMessage({
                            'text': element.description
                        })
                    }
                }.bind(this));

            }.bind(this), false);

            this.canvas.addEventListener('mousemove', function (event) {
                //                this.canvasContext.drawImage(this.houseImage, element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);

                var x = event.pageX - this.canvas.offsetLeft,
                    y = event.pageY - this.canvas.offsetTop;
                var hoversOnElement = false;
                if (this.roomList.length <= 0) {
                    return;
                }
                this.roomList.forEach(function (element) {
                    if (y > element.y - (element.height / 2) && y < element.y - (element.height / 2) + element.height &&
                        x > element.x - (element.width / 2) && x < element.x - (element.width / 2) + element.width) {
                        hoversOnElement = true;
                    }
                }.bind(this));
                if (hoversOnElement) {
                    this.canvas.style.cursor = "pointer";
                } else {
                    this.canvas.style.cursor = "default";

                }
            }.bind(this), false);

            this.backgroundImage = new Image();

            this.backgroundImage.src = require('../../assets/enaqgmaps.jpg');
            this.houseImage = new Image();
            this.houseImage.src = require('../../assets/house.png');
            this.backgroundImage.onload = function () {

                this.initRooms();
                this.drawCanvas();
            }.bind(this)
        },
        initRooms() {
            this.addRoom(2, 250, 90, 120, 100, '#000000', null, 'house.png');
            this.addRoom(3, 460, 90, 120, 100, '#000000', 'food', 'house.png');
            this.addRoom(4, 320, 270, 120, 100, '#000000', 'food', 'house.png');
            this.addRoom(5, 390, 850, 120, 100, '#000000', 'scooter car auto bike fahrrad', 'house.png');
            this.addRoom(6, 250, 740, 120, 100, '#000000', '', 'house.png');
            this.addRoom(7, 120, 800, 120, 100, '#000000', 'stromzähler', 'house.png');
            this.addRoom(0, 520, 800, 50, 50, '#000000', 'stromzähler', 'power.png');

        },
        addRoom(translationId, x, y, width, height, color, keywords = '', image = '') {
            //   this.rooms.push(['name':'Raum 1','x':5,'y':5,'width':30,'height':40])
            var translatedCoords = this.translateCoords(x, y);
            var translatedSize = this.translateCoords(width, height)
            this.rooms.push({
                'name': this.$t('enaq_translation_room_name_id_' + translationId),
                'description': this.$t('enaq_translation_room_description_id_' + translationId),
                'x': translatedCoords.x,
                'y': translatedCoords.y,
                'width': translatedSize.x,
                'height': translatedSize.y,
                'realx': x,
                'realy': y,
                'realwidth': width,
                'realheight': height,
                'color': color,
                'keywords': keywords,
                'image': image
            })

        },
        clearCanvas() {
            //  this.canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            this.canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

        },

        drawCanvas() {
            this.canvasContext.drawImage(this.backgroundImage, 0, 0, this.canvasWidth, this.canvasHeight);

            this.drawRooms();

        },
        //Canvas will be a 1000 x 1000-grid, positions need to be translatet with actual canvas-size
        //Example for position 150 x 150:
        //Canvassize 1000 x 1000 : Positon = 150 x 150
        //Canvassize 100 x 100: Position = 15 x 15
        //Vanvassize 500 x 800: Position = 75 x  120
        translateCoords(x, y) {
            var newX = x / 1000 * this.canvasWidth;
            var newY = y / 1000 * this.canvasHeight;

            return {
                x: newX,
                y: newY
            }
        },

        drawRooms() {
            console.log("Length: " + this.roomList.length)

            if (this.roomList.length <= 0) {
                return;
            }
            this.roomList.forEach(function (element) {

                var coords = this.translateCoords(element.x, element.y);
                var elementX = coords.x;
                var elementY = coords.y;

                var size = this.translateCoords(element.width, element.height);
                var elementWidth = size.x;
                var elementHeight = size.y;
                /*
                                this.canvasContext.fillStyle = element.color;
                                this.canvasContext.beginPath();
                                this.canvasContext.rect(elementX - (elementWidth / 2), elementY - (elementHeight / 2), elementWidth, elementHeight);
                                this.canvasContext.stroke();
                                this.canvasContext.drawImage(this.houseImage, elementX - (elementWidth / 2), elementY - (elementHeight / 2), elementWidth, elementHeight);
                                this.canvasContext.font = "13px Arial";
                                this.canvasContext.fillText(element.name, elementX - (elementWidth / 2) + 25,  elementY - (elementHeight / 2)+(elementHeight/2)+10);
                           */
                this.canvasContext.fillStyle = element.color;
                this.canvasContext.beginPath();
                this.canvasContext.rect(element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                this.canvasContext.stroke();

                if (element.image != null && element.image != undefined && element.image != '') {

                    let elementImage = new Image();
                    elementImage.src = require('../../assets/' + element.image);
                    elementImage.onload = function () {
                        this.canvasContext.drawImage(elementImage, element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);

                        this.canvasContext.font = 90 + "% Arial";

                        this.canvasContext.fillText(element.name, element.x - (element.width / 2) + 22, element.y - (element.height / 2) + (element.height / 2) + 10);

                    }.bind(this)
                } else {
                    this.canvasContext.font = 90 + "% Arial";
                    if (element.icon != null && element.icon != undefined && element.icon != '') {
                        this.canvasContext.font = '30px FontAwesome';
                        var icon = element.icon
                        //    this.canvasContext.fillText(icon,element.x - (element.width / 2), element.y + (element.height / 2)-20, element.width, element.height);

                    }

                    this.canvasContext.font = 90 + "% Arial";

                    this.canvasContext.fillText(element.name, element.x - (element.width / 2) + 22, element.y - (element.height / 2) + (element.height / 2) + 10);

                }

            }.bind(this));
            //     });​
        },

    },
    computed: {
        canvasWidth() {
            //   return '850'
            return document.documentElement.clientWidth * 0.55
            return document.documentElement.clientWidth * 0.8
        },
        canvasHeight() {
            //  return '600';
            return document.documentElement.clientWidth * 0.55
        },
        roomList() {
            if (this.searchInput == '') {
                return this.rooms
            } else {
                let roomList = [];
                console.log("change roomlist")
                this.rooms.forEach(function (element) {
                    console.log("check " + element.name)
                    if (element.name.toUpperCase().includes(this.searchInput.toUpperCase()) || (element.keywords != null && element.keywords != undefined && element.keywords != '' && element.keywords.toUpperCase().includes(this.searchInput.toUpperCase()))) {
                        roomList.push(element)
                    }
                }.bind(this));
                this.clearCanvas();
                return roomList;
            }
        }
    },
    watch: {
        roomList: function (newList, oldList) {
            this.clearCanvas();
            this.drawCanvas();
        }
    },
}
</script>

<style scoped>
.enaqmaps {
    width: 850px;
    height: 600px;
    background: url("../../assets/enaqgmaps.jpg");
    background-repeat: no-repeat;
    overflow: hidden;

}
</style>
